import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=4680a1bc"
import script from "./Sharing.vue?vue&type=script&lang=js"
export * from "./Sharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports